import axios from "axios";
import config from "./config";

export const createPasswordChallenge = (body) => {
  return axios.post("/challenges/create_password", body, config);
}